export const ExperimentsConsts = {
  MembersAreaLazyLoad: 'specs.bookings.members-area-lazy-load',
  WixFormsMigration: 'specs.bookings.WixFormsMigration',
  UseMoment: 'specs.bookings.MyBookingsUseMoment',
  BookFlowSettings: 'specs.bookings.BookFlowSettings',
  BookingsAppSettingsMigration:
    'specs.bookings.bookings-app-settings-migration',
};
